import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from '@atlassian/jira-issue-table-inline-issue-create/src/ui/inline-create-form/issue-type-dropdown/__generated__/IssueTypeDropdownQuery.graphql';

type EntryPointParams = {
	cloudId: string;
	projectKey: string | undefined;
};

export const reparentModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(/* webpackChunkName: "async-reparent-modal-dialog" */ './ReparentModalEntryPoint.tsx'),
	),
	getPreloadProps: ({ cloudId, projectKey }: EntryPointParams) =>
		({
			queries: {
				projectData: {
					parameters,
					options: {
						fetchPolicy: 'store-or-network',
					},
					variables: {
						cloudId,
						projectKey: projectKey ?? '',
					},
				},
			},
		}) as const,
});
